import { ReactComponent as Icon } from 'assets/menuWide/user.svg'
import React from 'react'

export default function UserIcon(props: any) {
  return (
    <Icon {...props} />
  )
}